import {createFileRoute} from "@tanstack/react-router";

import {FeedPage} from "@/features/feed/pages/FeedPage";

export const Route = createFileRoute("/_app/")({
  component: Index,
});

function Index() {
  return <FeedPage />;
}
